import { makeAutoObservable } from 'mobx';
import { ToastProps } from '../components/base/Toast';

export class ToastManager {
  private toastsMap = new Map<string, ToastProps>();

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  addToast(toast: ToastProps) {
    const id = Math.random().toString(36).slice(2);
    const animationTime = 1_000;
    const timeoutTime = (toast.duration ?? 3_000) + animationTime;

    this.toastsMap.set(id, toast);
    setTimeout(() => this.removeToast(id), timeoutTime);
    return toast;
  }

  removeToast = (id: string) => {
    this.toastsMap.delete(id);
  };

  get toasts(): {
    id: string;
    toast: ToastProps;
  }[] {
    return Array.from(this.toastsMap).map(([id, toast]) => ({ id, toast }));
  }
}
